'use strict';

$('.recipe-steps__text ol > li').each(function(index) {
    var content = $(this).html();
    var uniqueId = 'step' + index;

    $(this).html(
    '<input id="' + uniqueId + '" type="checkbox">' +
      '<label for="' + uniqueId + '">' +    
        '<span class="recipe-step-text">' + content + '</span>' +
      '</label>'
    );
});


// WEBPACK FOOTER //
// ./cartridges/app_fh/cartridge/client/default/js/components/strikethrough.js